var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M11.5313 5.46967C11.8242 5.76256 11.8242 6.23744 11.5313 6.53033L6.81164 11.25H19.001C19.4152 11.25 19.751 11.5858 19.751 12C19.751 12.4142 19.4152 12.75 19.001 12.75H6.81164L11.5313 17.4697C11.8242 17.7626 11.8242 18.2374 11.5313 18.5303C11.2384 18.8232 10.7635 18.8232 10.4706 18.5303L4.47065 12.5303C4.32999 12.3897 4.25098 12.1989 4.25098 12C4.25098 11.8011 4.32999 11.6103 4.47065 11.4697L10.4706 5.46967C10.7635 5.17678 11.2384 5.17678 11.5313 5.46967Z","fill":"currentColor"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
